export async function readCloudJsonResponse(response: Response, fallbackMessage: string): Promise<unknown> {
  try {
    return (await response.json()) as unknown;
  } catch {
    throw new Error(fallbackMessage);
  }
}

export function readCloudApiErrorMessage(body: unknown, fallbackMessage: string): string {
  if (
    body &&
    typeof body === 'object' &&
    'error' in body &&
    body.error &&
    typeof body.error === 'object' &&
    'code' in body.error &&
    'message' in body.error &&
    typeof body.error.code === 'string' &&
    typeof body.error.message === 'string'
  ) {
    return `${body.error.code}: ${body.error.message}`;
  }

  return fallbackMessage;
}
